export default __webpack_public_path__ + "static/media/apy.6aa47360.svg";